import React from 'react';
import styled from 'styled-components';
import { Text } from '../Typography/Typography';

const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  margin-bottom: 24px;
`;

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  cursor: ${props => props.$clickable ? 'pointer' : 'default'};
  flex: 1;
`;

const StepDot = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${props => props.$active || props.$completed ? '#2563eb' : '#fff'};
  border: 2px solid ${props => props.$active || props.$completed ? '#2563eb' : '#e2e8f0'};
  color: ${props => props.$active || props.$completed ? '#fff' : '#64748b'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;
  margin-bottom: 8px;
`;

const StepLine = styled.div`
  position: absolute;
  top: 16px;
  left: ${props => props.$offset}%;
  height: 2px;
  width: ${props => props.$lineWidth}%;
  background-color: #e2e8f0;
  z-index: 1;
`;

const StepProgressLine = styled.div`
  position: absolute;
  top: 16px;
  left: ${props => props.$offset}%;
  height: 2px;
  width: ${props => props.$width}%;
  background-color: #2563eb;
  z-index: 1;
  transition: width 0.3s ease;
`;

const StepLabel = styled(Text)`
  font-size: 13px;
  font-weight: ${props => props.$active ? '600' : '400'};
  color: ${props => props.$active ? '#1e293b' : '#64748b'};
  text-align: center;
  white-space: nowrap;
`;

const Stepper = ({ steps = [], currentStep = 0, onStepClick }) => {
  if (!steps || steps.length === 0) return null;

  const handleStepClick = (index) => {
    if (onStepClick && index <= currentStep) {
      onStepClick(index);
    }
  };

  const n = steps.length;
  const lineOffset = (0.5 / n) * 100;
  const lineWidth = ((n - 1) / n) * 100;
  const progressWidth = (currentStep / n) * 100;

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <StepLine $offset={lineOffset} $lineWidth={lineWidth} />
      <StepProgressLine $offset={lineOffset} $width={progressWidth} />

      <StepperContainer>
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isActive = index === currentStep;
          const isClickable = index <= currentStep;

          return (
            <StepWrapper
              key={index}
              $clickable={isClickable}
              onClick={() => handleStepClick(index)}
            >
              <StepDot $active={isActive} $completed={isCompleted}>
                {isCompleted ? '✓' : index + 1}
              </StepDot>
              <StepLabel $active={isActive}>
                {step.label || step.name}
              </StepLabel>
            </StepWrapper>
          );
        })}
      </StepperContainer>
    </div>
  );
};

export default Stepper;
